// extracted by mini-css-extract-plugin
module.exports = {"body":"BasePagination_body_27zaJ"};